export enum ActivityTabKey {
  MY_REPORTS = 'my-reports',
  ALL_REPORTS = 'all',
  SCHEDULED = 'scheduled',
  SHARED = 'shared-with-me',
  DELETED = 'deleted'
}
